// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__X-KQU {
  padding: 0.36rem 0.72rem; }
  @media (max-width: 768px) {
    .styles_container__X-KQU {
      padding: 0.18rem 0.36rem; }
      .styles_container__X-KQU p {
        font-size: 0.72rem; } }
  .styles_container__X-KQU p {
    text-transform: capitalize;
    line-height: 0.72rem;
    font-size: 0.72rem; }

.styles_ocean_blue__w5AOx {
  color: #72abab;
  border-width: 3px;
  border-color: #72abab;
  border-radius: 10%;
  border-style: dotted;
  transition: all 0.5s ease-in-out;
  opacity: 0.9;
  cursor: pointer; }
  .styles_ocean_blue__w5AOx:hover {
    opacity: 1;
    border-radius: 36%;
    font-weight: 700; }

.styles_pond_green__SaBar {
  color: #72bbbb;
  border-width: 3px;
  border-color: #72bbbb;
  border-radius: 10%;
  border-style: dotted;
  transition: all 0.5s ease-in-out;
  opacity: 0.9;
  cursor: pointer; }
  .styles_pond_green__SaBar:hover {
    opacity: 1;
    border-radius: 36%;
    font-weight: 700; }

.styles_grey72__hHyXD {
  color: #808080b8;
  border-width: 3px;
  border-color: #808080b8;
  border-radius: 10%;
  border-style: dotted;
  transition: all 0.5s ease-in-out;
  opacity: 0.9;
  cursor: pointer; }
  .styles_grey72__hHyXD:hover {
    opacity: 1;
    border-radius: 36%;
    font-weight: 700; }

.styles_success_street__S\\+dJB {
  color: #723618;
  border-width: 3px;
  border-color: #723618;
  border-radius: 10%;
  border-style: dotted;
  transition: all 0.5s ease-in-out;
  opacity: 0.9;
  cursor: pointer; }
  .styles_success_street__S\\+dJB:hover {
    opacity: 1;
    border-radius: 36%;
    font-weight: 700; }

.styles_somewhat_certain__Hx-cy {
  color: #183672;
  border-width: 3px;
  border-color: #183672;
  border-radius: 10%;
  border-style: dotted;
  transition: all 0.5s ease-in-out;
  opacity: 0.9;
  cursor: pointer; }
  .styles_somewhat_certain__Hx-cy:hover {
    opacity: 1;
    border-radius: 36%;
    font-weight: 700; }

.styles_green__HcohS {
  color: white;
  border-width: 3px;
  border-color: white;
  border-radius: 10%;
  border-style: dotted;
  transition: all 0.5s ease-in-out;
  opacity: 0.9;
  cursor: pointer;
  background: linear-gradient(to right, #72ab72b8, #8000805c);
  font-weight: 900; }
  .styles_green__HcohS:hover {
    opacity: 1;
    border-radius: 36%;
    font-weight: 700; }

button.styles_container__X-KQU {
  color: #72abab;
  border-width: 3px;
  border-color: #72abab;
  border-radius: 10%;
  border-style: dotted;
  transition: all 0.5s ease-in-out;
  opacity: 0.9;
  cursor: pointer; }
  button.styles_container__X-KQU:hover {
    opacity: 1;
    border-radius: 36%;
    font-weight: 700; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Stamp/styles.module.scss","webpack://./src/modules/Core/styles/mixins.scss","webpack://./src/modules/Core/styles/variables.scss","webpack://./src/modules/roadmaps/components/StampGatewayButton/styles.module.scss"],"names":[],"mappings":"AAoBA;EACI,wBAAwB,EAAA;ECb1B;IDYF;MAIQ,wBAAwB,EAAA;MAJhC;QAOY,kBAAkB,EAAA,EAErB;EATT;IAaQ,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB,EAAA;;AAI1B;EAnCI,cEmCgB;EFlChB,iBAAiB;EACjB,qBEiCgB;EFhChB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,eAAe,EAAA;EAEf;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB,EAAA;;AA2BxB;EAvCI,cEiCgB;EFhChB,iBAAiB;EACjB,qBE+BgB;EF9BhB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,eAAe,EAAA;EAEf;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB,EAAA;;AA+BxB;EA3CI,gBEac;EFZd,iBAAiB;EACjB,uBEWc;EFVd,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,eAAe,EAAA;EAEf;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB,EAAA;;AAmCxB;EA/CI,cE6CoB;EF5CpB,iBAAiB;EACjB,qBE2CoB;EF1CpB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,eAAe,EAAA;EAEf;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB,EAAA;;AAuCxB;EAnDI,cE2CqB;EF1CrB,iBAAiB;EACjB,qBEyCqB;EFxCrB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,eAAe,EAAA;EAEf;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB,EAAA;;AA2CxB;EAvDI,YAwD4B;EAvD5B,iBAAiB;EACjB,mBAsD4B;EArD5B,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,eAAe;EAkDf,2DAAiE;EACjE,gBAAgB,EAAA;EAjDhB;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB,EAAA;;AGdxB;EHEI,cEmCgB;EFlChB,iBAAiB;EACjB,qBEiCgB;EFhChB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,eAAe,EAAA;EGTnB;IHYQ,UAAU;IACV,kBAAkB;IAClB,gBAAgB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n@import \"src/modules/Core/styles/mixins.scss\";\n\n@mixin bordered-text($color) {\n    color: $color;\n    border-width: 3px;\n    border-color: $color;\n    border-radius: 10%;\n    border-style: dotted;\n    transition: all 0.5s ease-in-out;\n    opacity: 0.9;\n    cursor: pointer;\n\n    &:hover {\n        opacity: 1;\n        border-radius: 36%;\n        font-weight: 700;\n    }\n}\n\n.container {\n    padding: 0.36rem 0.72rem;\n\n    @include mobile {\n        padding: 0.18rem 0.36rem;\n\n        & p {\n            font-size: 0.72rem;\n\n        }\n    }\n\n    & p {\n        text-transform: capitalize;\n        line-height: 0.72rem;\n        font-size: 0.72rem;\n    }\n}\n\n.ocean_blue {\n    @include bordered-text($ocean_blue);\n}\n\n.pond_green {\n    @include bordered-text($pond_green);\n}\n\n.grey72 {\n    @include bordered-text($grey72);\n}\n\n.success_street {\n    @include bordered-text($success_street);\n}\n\n.somewhat_certain {\n    @include bordered-text($somewhat_certain);\n}\n\n.green {\n    @include bordered-text(white);\n    background: linear-gradient(to right, $kermit_green72, $purple36);\n    font-weight: 900;\n}","// @import \"src/modules/Core/styles/mixins.scss\";\n@mixin respond-to($breakpoint) {\n  @media (max-width: $breakpoint) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin multilineText($lines){\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: -webkit-box;\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n","@import \"src/modules/Core/sub-modules/ui-kit/components/Stamp/styles.module.scss\";\n\nbutton.container {\n    @include bordered-text($ocean_blue);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__X-KQU`,
	"ocean_blue": `styles_ocean_blue__w5AOx`,
	"pond_green": `styles_pond_green__SaBar`,
	"grey72": `styles_grey72__hHyXD`,
	"success_street": `styles_success_street__S+dJB`,
	"somewhat_certain": `styles_somewhat_certain__Hx-cy`,
	"green": `styles_green__HcohS`
};
export default ___CSS_LOADER_EXPORT___;
